import { autoinject, observable, computedFrom } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { Reflection } from "../../../utilities/reflection";
import { IconsStorage } from "./icon-storage";

@autoinject
export class IconPickerDialog {

    selectedIcon: string;
    onPick: (icon: string) => void;
    icons: { name: string, displayName: string, code: string }[] = [];

    constructor(private dialogClientService: DialogClientService, private iconsStorage: IconsStorage) { }

    @observable()
    filterSearch: string;

    @computedFrom(
        Reflection.getPropertyPath<IconPickerDialog>(z => z.filterSearch),
        Reflection.getPropertyPath<IconPickerDialog>(z => z.icons)
    )
    get filteredIcons() {
        return this.filterSearch ? 
        this.icons.filter(x => x.displayName.indexOf(this.filterSearch.toLowerCase()) > -1) : 
        this.icons;
    }

    activate(model: { onPick: (icon: string) => void }) {
        this.onPick = model.onPick;
        this.iconsStorage.getIcons().then(() => {
            this.icons = this.iconsStorage.icons;
        });
    }

    selectIcon(icon: any) {
        if (icon) {
            this.selectedIcon = icon.name;
        } else {
            this.selectedIcon = null;
        }
    }

    close() {
        this.dialogClientService.hide();
    }
}
